import { CSRF_TOKEN } from "../constants";
import { upload } from "../api/cloudinary";

export default ({ path, redirect, remainingPhotos }) => ({
  loading: false,
  totalUploads: 0,
  completedUploads: 0,

  get label() {
    if (this.loading) {
      return `Uploading... (${this.completedUploads}/${this.totalUploads})`;
    }

    return "Select photos";
  },

  onClick() {
    this.$refs.input.click();
  },

  onChange(event) {
    if (event.target.files.length > remainingPhotos) {
      return alert(
        `You can only upload ${remainingPhotos} more photo(s) for this room.`,
      );
    }

    this.handleFiles(event.target.files);
  },

  async handleFiles(files) {
    this.loading = true;
    this.totalUploads = files.length;
    this.completedUploads = 0;

    const uploads = Array.from(files).map((file) => this.uploadFile(file));

    try {
      await Promise.all(uploads);

      this.loading = false;

      this.onSuccess();
    } catch (error) {
      console.error(error);

      this.loading = false;

      alert(
        `Something has gone wrong with the upload, please try again later or contact support.`,
      );
    }
  },

  async uploadFile(file) {
    const response = await upload(file);

    if (response === null) {
      alert(
        "Something has gone wrong, please try again later or contact support.",
      );
      return;
    }

    const json = await response.json();

    await fetch(path, {
      headers: {
        "X-CSRF-TOKEN": CSRF_TOKEN,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        public_id: json.public_id,
        perception_hash: json.phash,
      }),
    }).catch((error) => {
      console.error(error);
      alert(
        "Something has gone wrong, please try again later or contact support.",
      );
    });

    this.completedUploads++;
  },

  onSuccess() {
    window.location.href = redirect;
  },
});
